import { render, staticRenderFns } from "./uploadImgs.vue?vue&type=template&id=5842505e"
import script from "./uploadImgs.vue?vue&type=script&lang=js"
export * from "./uploadImgs.vue?vue&type=script&lang=js"
import style0 from "./uploadImgs.vue?vue&type=style&index=0&id=5842505e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports